<div class="flex flex-col lg:flex-row gap-3 p-3 h-full w-full overflow-hidden">
    <div class="w-full lg:w-[18.75rem] lg:min-w-[12.5rem] lg:shrink h-full overflow-hidden">
        <app-document-types-list [documentTypes]="docTypes" [docTypeLoading]="docTypeLoading"
            (documentTypeSelected)="onGetDoctype($event)" (refetchDocumentTypes)="getDocumentTypes()">
        </app-document-types-list>
    </div>
    <div class="w-full lg:flex-1 lg:min-w-0 flex flex-col gap-2 h-full min-h-0 overflow-hidden">
        <div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center gap-3 flex-shrink-0">
            <div class="flex-1">
                <h2 class="font-bold text-lg sm:text-xl break-words">{{selectedDocType.name}}
                </h2>
            </div>
            <div class="items-center flex justify-end w-full sm:w-auto">
                <app-button variant="filled" severity="primary" label="Connect Tag Types" icon="pi pi-plus"
                    (clicked)="openConnectDialog()" />
            </div>
        </div>
        <div class="flex flex-col gap-2 overflow-y-auto flex-1 min-h-0">
            @if(linkedTagsLoading){
            @for (item of getSkeletonCount(5); track $index) {
            <div class="w-full h-20 pt-2">
                <p-skeleton width="100%" height="90%" />
            </div>
            }
            }
            @else{
            @if(!linkedTags.length) {
            <p class="text-center">No Connected Tag Types found</p>
            }
            @for (tag of linkedTags; track tag._id; let i = $index) {
            <p-card pDraggable pDroppable (onDragStart)="dragStart($index)" (onDrop)="dropTag($index)" dragEffect="move"
                class="tag-card border p-0">
                <div class="flex flex-row gap-3 items-center w-full">
                    <i class="pi pi-bars cursor-move text-gray-400"></i>
                    <div class="flex flex-row flex-grow gap-2 justify-between items-center">
                        <div class="column-60">
                            <div class="flex flex-row gap-4 items-center">
                                <span class="flex items-center">
                                    <i class="{{TAG_TYPES_ICONS[(tag?.tagType)?.toString()??'']}} || pi pi-tag "></i>
                                </span>
                                <span class="flex flex-col">
                                    <span class="font-bold">{{tag.name}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="columm-40">
                            <div class="flex flex-row gap-4 items-center">
                                <span class="flex flex-row gap-2">
                                    <app-button variant="outlined" severity="danger" label="Delink" icon="pi pi-trash"
                                        (clicked)="deleteLinkedTag(tag)" />
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </p-card>
            }
            }
        </div>
    </div>
</div>

<app-file-selection [(visible)]="connectTagsVisible" [config]="fileSelectionConfig" [fetch]="fetchTagTypes"
    [fileItemTemplate]="tagItemTemplate" [selectedFileTemplate]="tagSelectedTemplate"
    (onSubmit)="submitDocSelection($event)">

    <ng-template #tagItemTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <app-checkbox [value]="selected" (onChange)="toggleSelection($event)" [config]="{ binary: true }" />
            <span class="text-sm text-gray-900">{{ file.name }}</span>
        </div>
    </ng-template>

    <ng-template #tagSelectedTemplate let-file let-toggleSelection="toggleSelection">
        <div class="flex items-center justify-between">
            <span class="text-sm text-gray-900">{{ file.name }}</span>
            <app-button variant="outlined" severity="danger" icon="pi pi-trash" size="sm"
                (clicked)="toggleSelection({ checked: false })" />
        </div>
    </ng-template>
</app-file-selection>

<p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col align-items-center p-5 surface-overlay border-round w-[30rem]">
            <span class="font-bold text-2xl block mb-2 mt-4">
                {{ message.header }}
            </span>
            <p class="mb-0">{{ message.message }}</p>
            <div class="flex justify-end items-end float-left gap-2 mt-4">
                <app-button variant="filled" severity="primary" label="Yes" icon="pi pi-check"
                    (clicked)="handleConfirmAccept(message)" />
                <app-button variant="outlined" severity="danger" label="No" icon="pi pi-times"
                    (clicked)="handleConfirmReject(message)" />
            </div>
        </div>
    </ng-template>
</p-confirmDialog>